import React, { useEffect, useState ,useRef } from "react"
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CardImg
} from "reactstrap"
import { AvForm } from 'availity-reactstrap-validation';
import { toast } from "react-toastify"
import BaseService from "services/BaseService";
import "./style.scss"
import BuildingService from "services/Admin/BuildingService"
import axios from "axios";
import CropImg from "./CropImg";
import PropertyService from "services/Admin/PropertyService";

function ShapeImgModal({ modal, toggle, index, addShapeImgHandler, image, hotspot }) {
    const [img, setImg] = useState(null)
    const [images, setImgages] = useState([])
    const buildingService = new BuildingService()
    const propertyService = new PropertyService()
    const [percent, setPercent] = useState(0)
    const [openLibrary, setOpenLibrary] = useState(false)
    const [loading, setLoading] = useState(false)
    const [loadingCrop, setLoadingCrop] = useState(false)
    const cancelTokenSource = useRef();
    const [cropModal, setCropModal] = useState(false)

    const toggleCrop = () => setCropModal(!modal);
    const [imageCrop, setImageCrop] = useState("");
    const [fileName, setFileName] = useState(null)

    const onImageSelected = (e) => {
        const reader = new FileReader();
        setFileName(e.target.files[0])
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function (e) {
            setImageCrop(reader.result);
            setCropModal(true);
        };
    }
    
    const uploadImage = (file) =>{
        setLoadingCrop(true)
        new BaseService().postUpload(file).then((res) => {
            const createdFiles = { ...res.data.data, shapes: [], fromLibrary: false };
            setImg({ ...createdFiles })
            setCropModal(false);
            setLoadingCrop(false)
        })
    }

    const addImagesHandler = (e) => {
        setLoading(true)
        let files = e.target.files
        const filesData = Object.values(files)
        const uploadedImgs = []
        cancelTokenSource.current = axios.CancelToken.source();
 
        const options = {
            cancelToken: cancelTokenSource.current.token,
            ignoreInterceptors: true,
            onUploadProgress: (progressEvent) => {
                const { loaded, total } = progressEvent;
                let percentValue = (loaded * 100) / total
                setPercent((p) => percentValue > p ? percentValue : p)
            }
        }
        if (filesData.length) {
            
            Promise.all(
                filesData.map(async (file) => {
                    let res = await new BaseService().postUpload(file, options);


                    const createdFiles = { ...res.data.data, shapes: [], fromLibrary: false };
                    uploadedImgs.push(createdFiles)
                }),
            ).then(() => {
                setPercent(0)
                setImg({ ...uploadedImgs[0] })
            }).catch((err) => { 

                setPercent(0)
            })
        }
    }

    useEffect(() => {
        if (image) {
            setImg({ ...image })
        }
    }, [image])

    useEffect(() => {
        return () => {
            cancelTokenSource?.current?.cancel()
          }
    }, [])

    useEffect(() => {
        if (hotspot ?.type === "building") {
            buildingService.getDropDown().then(res => {
                const seelected = res.data.find(item => item.id === hotspot ?.id)
                if(!!seelected){
                    setImgages(seelected.images)
                }
            })
        } else if (hotspot ?.type === "unit") {
            propertyService.getDropDown(null, "Left").then(res => {
                const seelected = res.data.find(item => item?.id === hotspot ?.id)
                setImgages(seelected?.images)
            })
        }
    }, [hotspot]);

    return (
        <AvForm
            className='form-horizontal'
            onValidSubmit={(e, v) => {
                handleValidSubmit(e, v)
            }}>
            <Modal isOpen={modal} toggle={() => {
                if (loading) {
                    cancelTokenSource.current.cancel()
                }
                toggle()
            }} className="scrollbar-container mt-5 internal-modal">
                <ModalHeader toggle={() => {
                if (loading) {
                    cancelTokenSource.current.cancel()
                }
                toggle()
            }}>
                    Add New Image
                <br />
                </ModalHeader>
                <ModalBody>
                    <Row>
                        {percent > 0 ?
                        <div className="ml-1 mr-2">
                            <div className="progress mb-1 p-0 ">
                                <div
                                    className="progress-bar progress-bar-striped"
                                    role="progressbar"
                                    style={{ width: percent + '%' }}
                                    aria-valuenow={`${percent}`}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                </div>
                                </div>
                            </div> : <div  ></div>}
                        {img ? <Col className="parent-div">
                            <CardImg className="position-relative" src={img ?.path} style={{ width: "100%", height: "210px", objectFit: "cover", borderRadius: "10px" }}  >
                            </CardImg>
                            <button
                                className="position-absolute overflow-hidden text-danger fw-bold p-1 font-size-16"
                                onClick={() => {
                                    setImg(null)
                                    setOpenLibrary(false)
                                }}
                                style={{ top: "5px", right: "15px", border: "none", background: "white", borderRadius: "15px", height: "30px", width: "30px", paddingRight: "20px", paddingTop: "5px" }}
                            >
                                x
                                    </button>
                            {!openLibrary ? <button
                                className="position-absolute overflow-hidden"
                                style={{ bottom: "5px", right: "15px", border: "none", background: "white", borderRadius: "19px", height: "38px", width: "38px", paddingRight: "20px", paddingTop: "5px" }}
                            ><i className="fas fa-pen  overflow-hidden text-success p-2 "

                            >
                                </i>
                                <input type="file" name="upfile" accept="image/*" onChange={onImageSelected} />
                            </button> : null}

                        </Col> : null}
                        {!img && !openLibrary ? <Col md={12} className="parent-div my-1" >
                            <div className="p-2 bg-light " style={{ borderRadius: "10px" }}>
                                <button type="button" className="px-4 w-100 btn-upload  font-size-16 "
                                    style={{ border: "2px dashed rgb(202, 223, 247)", borderRadius: "10px", height: "150px", background: "#F3F3F9" }}>
                                    <div><i className="fas fa-cloud-upload-alt text-success"></i></div>
                                    <div>Click to upload or drag and drop</div>
                                    <p className="text-primary fw-bold btn-hover" style={{ marginRight: "130px", textDecoration: "underline" }}>from computer</p></button>
                                <span className="or-btn">or</span>
                                <p className="library-btn font-size-16 text-primary fw-bold"
                                    onClick={(e) => {
                                        if (!hotspot) {
                                            toast.error("Please, Select Hotspot Type")
                                        } else {
                                            if (images.length === 0) {
                                                toast.error("This Hotspot Type doesn't contain images")
                                                setOpenLibrary(false)

                                            } else {
                                                setOpenLibrary(true)
                                            }

                                        }

                                    }}>from library</p>
                                <input type="file" name="upfile" accept="image/*" onChange={onImageSelected} />
                            </div>
                        </Col> : null}
                        {!img && openLibrary ? <Col className="d-flex flex-wrap parent-div">
                            {images ?.length > 0 ? images ?.map(item => {
                                return (
                                    <div key={item.id} className="mx-1 my-2 d-flex"
                                        style={{ width: "80px", height: "70px", border: img ?.id === item.id ? "2px solid black" : "none" }}
                                        onClick={() => setImg({ ...item, shapes: [], fromLibrary: true })}>
                                        <img src={item.path} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                    </div>
                                )
                            })
                                : <div className="m-auto">
                                    <p>No Availabel  Images In library</p>
                                    <button className="btn btn-light w-70 mx-4"
                                        onClick={() => {
                                            setOpenLibrary(false)
                                        }}>Close Library</button>
                                </div>}
                        </Col> : null}
                    </Row>
                </ModalBody>

                <Row className="p-0 pt-1 m-0 d-flex justify-content-between">
                    <Col md={6}>
                        <button
                            type='button'
                            onClick={toggle}
                            className='btn btn-secondary w-30'>
                            Cancel
                        </button>
                    </Col>
                    <Col md={6} className="d-flex justify-content-end">
                        <button
                            type='button'
                            onClick={() => {
                                if (img) {
                                    addShapeImgHandler(index, img)
                                    toggle()
                                } else {
                                    toast.error("Select or upload  image ")
                                }
                            }}
                            disabled={ percent === 0 ? false : percent === 100 ? false : true}
                            className='btn btn-success w-30'>
                            Submit
                        </button>
                    </Col>
                </Row>
            </Modal>
            {cropModal && <CropImg
                modal={cropModal}
                toggle={toggleCrop}
                img={imageCrop}
                uploadImage = {(file)=> uploadImage(file)}
                fileName={fileName}
                loadingCrop={loadingCrop}
            />}
        </AvForm>

    )
}

export default ShapeImgModal
